import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../commons/buttons/CustomMUIButton';
import { ReactComponent as EditPencilIcon } from '../../../../assets/images/EditPencil.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/images/Delete.svg';
import { Phone } from '../../../../models/UserInfo';
import { ButtonClassNames } from '../../../../models/Common';
import { TextButton, TextButtonClassNames } from '../../../commons/buttons/TextButton';
import { phoneNumberWithSpaces } from '../../../../utils';

interface BackupPhonesProps {
  handleAddPhone: () => void;
  changePhone: (phone: string, phoneId: number) => void;
  deletePhone: (phone: string, phoneId: number) => void;
  value: Phone[] | string | number | null;
}

export const BackupPhones: FC<BackupPhonesProps> = ({ changePhone, value, handleAddPhone, deletePhone }) => {
  const { t } = useTranslation();
  if (!Array.isArray(value)) {
    return (
      <TextButton
        label={`${t('buttons.addPhoneNumber')} +`}
        handleClick={handleAddPhone}
        className={TextButtonClassNames.PrimaryActive}
      />
    );
  }

  return (
    <>
      {value.map((el, index) => {
        return (
          <Fragment key={el.id}>
            <div className="account__info__item__description account__info__item__description__phone">
              {phoneNumberWithSpaces(el.value)}
              <div className="account__info__item__description_absolute account__info__item__description_absolute__button ">
                <CustomMUIButton
                  label={<EditPencilIcon />}
                  handleClick={() => changePhone(el.value, el.id)}
                  className={ButtonClassNames.IconFulfilled}
                  tooltipText={`${t('buttons.change')}`}
                />
              </div>
              <div className="account__info__item__description_absolute account__info__item__description_absolute__button account__info__item__description_absolute__button__delete">
                <CustomMUIButton
                  label={<DeleteIcon />}
                  handleClick={() => deletePhone(el.value, el.id)}
                  className={ButtonClassNames.IconFulfilled}
                  tooltipText={`${t('buttons.delete')}`}
                />
              </div>
            </div>
            {value.length - index - 1 !== 0 && <hr />}
          </Fragment>
        );
      })}
      {value.length < 3 && (
        <>
          <hr />
          <TextButton
            label={`${t('buttons.addPhoneNumber')} +`}
            handleClick={handleAddPhone}
            className={TextButtonClassNames.PrimaryActive}
          />
        </>
      )}
    </>
  );
};
